/**
 * Emerging Payments API
 * The public API for Emerging Payments.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class RequestPlacement {
    /**
    * A globally unique id.
    */
    'id': string;
    'context': any;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "context",
            "baseName": "context",
            "type": "any",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return RequestPlacement.attributeTypeMap;
    }
    
    public constructor() {
    }
}

